/** Only NULL means no recorded login. Missing timezone/data is not "Never". */
export function formatLastLogin(value: string | null, timeZone?: string): string {
  if (value === null) return "Never";
  if (!timeZone) return "Unavailable";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Unavailable";
  try {
    return new Intl.DateTimeFormat("en-US", {
      timeZone, year: "numeric", month: "short", day: "numeric",
      hour: "numeric", minute: "2-digit", timeZoneName: "short",
    }).format(date);
  } catch {
    return "Unavailable";
  }
}

export const accessStatusLabels = {
  ACTIVE: "Active", DISABLED: "Disabled",
  PENDING_ACTIVATION: "Invited", NO_ACCESS: "No Access",
} as const;
export type AccessStatus = keyof typeof accessStatusLabels;
